export enum EUnitOfMeasureMetricLabel {
    meter = 'm',
    kilonewtonPerSquareMeter = 'kN/m²',
    kilonewtonPerCubicMeter = 'kN/m³',
    meterPerSecond = 'm/s',
    millimeter = 'mm',
    squareKilometer = 'km²',
    kilometer = 'km',
    cubicMeterPerSecond = 'm³/s',
    cubicMeterPerSecondMeter = 'm³/s*m',
    squareMeter = 'm²',
    cubicMeter = 'm³',
    kiloPascal = 'kPa',
}

export enum EUnitOfMeasureImperialLabel {
    foot = 'ft',
    mile = 'mi',
    inch = 'in',
    squareMile = 'mi²',
    squareFoot = 'ft²',
    cubicFoot = 'ft³',
    footPerSecond = 'ft/s',
    cubicFootPerSecond = 'ft³/s',
    poundForcePerSquareFoot = 'lbf/ft²',
    poundForcePerCubicFoot = 'lbf/ft³',
    kiloPsi = 'ksi',
    cubicFootPerSecondFoot = 'ft³/s*ft',
}

export enum EUnitOfMeasureLabel {
    percentage = '%',
    deg = 'deg',
    rad = 'rad',
    perSecond = '1/s',
    years = 'years',
    hours = 'hours',
    days = 'days',
    amount = 'pz',
}
